<template>
  <md-field>
    <label>Hotels</label>
    <md-select multiple v-bind:value="value" v-on:input="$listeners['input']">
      <toggle-all-option-component :value="value" :types="types" @toggleAll="toggleAll"></toggle-all-option-component>
      <md-option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</md-option>
    </md-select>
  </md-field>
</template>

<script>
import SelectMixins from '@/components/Inputs/SelectMixins'
import ToggleAllOptionComponent from '@/components/Inputs/ToggleAllOptionComponent.vue'
export default {
  name: 'HotelSelect',
  components: { ToggleAllOptionComponent },
  mixins: [SelectMixins],
  props: {
    value: {
      type: Array,
    },
    hotels: {
      type: Array,
    },
  },
  computed: {
    types() {
      return this.hotels
    },
  },
}
</script>
